import { Injectable } from '@angular/core';
import {LabOrder} from './data/lab-order';

@Injectable()
export class UtilsService {

  constructor() { }

  // check that value not undefined, empty or blank spaces
  public static isEmpty(value): boolean {
    return (!value || !value.trim());
  }
  // check that value not undefined, empty or blank spaces or zero
  public static isEmptyOrZero(value): boolean {
    return (UtilsService.isEmpty(value) || value === '0');
  }

  // check that an order is a non-VSP order
  public static isPrivateOrder(order: LabOrder): boolean {
    return (order && order.labOrderNumber && order.labOrderNumber.toUpperCase().startsWith('Z'));
  }

  // check that an order was created via the LabAPI
  public static isAPIOrder(order: LabOrder): boolean {
    return (order && order.clientType && order.clientType.toUpperCase() === 'API');
  }

  public static formatRxPower(value: string): string {

    if (!value) {
      return null;
    } else {
      let formattedString: string;
      let signValue = '';
      let numberPortion: number;

      if (value.startsWith('+') || value.startsWith('-')) {
        signValue = value.charAt(0);
        numberPortion = Number(value.substring(1));
      } else {
        numberPortion = Number(value);
      }

      const numberAsString = numberPortion.toFixed(2);

      formattedString = signValue + numberAsString;

      return formattedString;
    }
  }

  public static sortObjectArray(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

  public static lowerCaseAllWordsExceptFirstLetters(text) {
    const updateText = text;
    if (!updateText) {
      return '';
    }
    if (updateText.length === 1) {
      return updateText.toUpperCase();
    } else {
      return updateText.replace(/\S*/g, function (word) {
        return word.toUpperCase().charAt(0) + word.slice(1).toLowerCase();
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/utils.service.ts